import { InputMask } from "@react-input/mask";
import ButtonUi from "@UI/ButtonUi";
import TooltipUI from "@UI/TooltipUI";
import { formatPhoneNumber } from "@utils";
import { useEffect, useState } from "react";

import "./style.scss";

const InputTextUi = ({
    inputPhoneRef,
    sendPhone,
    setSendPhone,
    setCodeValue,
    codeValue,
    inputFieldsState,
    error,
    maskType,
    handlePhone,
    handleClick,
    errorCode,
    setErrorCode,
    smsProviderType,
    shouldStopRef,
    setLoaderBtn,
    className = "",
    id,
    setTriggerIcon = () => {},
    icon,
    setInputFieldsState = () => {},
    autoFocus = false,
}) => {
    const [focus, setFocus] = useState();
    const [timer, setTimer] = useState(59000);
    const [focusMask, setFocusMask] = useState(false);

    useEffect(() => {
        if (smsProviderType === "pushMts") {
            setTimer(59000 * 2);
        }
    }, [smsProviderType]);

    useEffect(() => {
        if (sendPhone) {
            const intervalId = setTimeout(() => {
                if (timer > 0) {
                    setTimer(timer - 1000);
                } else {
                    clearTimeout(intervalId);
                }
            }, 1000);

            return () => {
                clearTimeout(intervalId);
            };
        }
    }, [sendPhone, timer]);

    const handleCode = (e) => {
        e.persist();

        let val = e.target.value;

        setCodeValue((prev) => {
            let obj = { ...prev, [e.target.id]: val.slice(-1) };
            return obj;
        });
        let id = val == "" ? Number(e.target.id) : Number(e.target.id) + 1;
        let inp = document.getElementById(id);
        if (inp) inp.focus();
    };

    const onKeyDown = (e) => {
        let val = e.target.value;

        if (e.keyCode == 8) {
            let id = val !== "" ? Number(e.target.id) : Number(e.target.id) - 1;
            let inp = document.getElementById(id);
            setCodeValue((prev) => {
                let obj = { ...prev, [e.target.id]: "" };
                return obj;
            });

            if (inp) inp.focus();
        }
    };

    useEffect(() => {
        if (sendPhone) return;

        const phone = inputFieldsState.phone;
        if (!phone || phone === false) return;

        const phoneDigits = String(phone).replace(/\D/g, "");
        if (phoneDigits.length <= 1) return;

        let cancelled = false;
        let attempts = 0;

        const syncPhoneToInput = () => {
            if (cancelled || attempts > 20) return;
            attempts += 1;

            const el = inputPhoneRef?.current;
            if (!el) {
                requestAnimationFrame(syncPhoneToInput);
                return;
            }

            const formatted = formatPhoneNumber(phoneDigits);
            if (formatted) {
                el.value = formatted;
                setFocusMask(true);
            }
        };

        syncPhoneToInput();

        return () => {
            cancelled = true;
        };
    }, [sendPhone]);

    const pasteHandler = () => {
        navigator.clipboard
            .readText()
            .then((text) => {
                if (text && text.length == 6) {
                    const initObj = {
                        0: "",
                        1: "",
                        2: "",
                        3: "",
                    };
                    const newObj = text.split("").reduce((acc, val, index) => {
                        acc[index] = val;
                        return acc;
                    }, initObj);
                    setCodeValue(newObj);
                }
            })
            .catch((err) => {
                console.error("Что-то пошло не так", err);
            });
    };

    const inputsItems = [0, 1, 2, 3].map((idx) => {
        return (
            <input
                placeholder={focus === idx ? "" : "_"}
                type="number"
                value={codeValue[idx].toLocaleString()}
                onChange={handleCode}
                onKeyDown={onKeyDown}
                onPaste={pasteHandler}
                onFocus={() => {
                    setFocus(idx);
                    setErrorCode(false);
                }}
                onBlur={() => setFocus(false)}
                className={`body_regular form__number-input-item  ${errorCode ? "error" : ""} ${className} ${codeValue[idx].toLocaleString().length ? "value" : ""}`}
                minLength={1}
                maxLength={1}
                min={1}
                max={1}
                key={idx}
                id={idx}
            />
        );
    });

    const sec = (ms) => {
        ms = Math.max(0, ms);
        const totalSeconds = Math.floor(ms / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        const formattedMinutes = String(minutes).padStart(2, "0");
        const formattedSeconds = String(seconds).padStart(2, "0");

        return `${formattedMinutes}:${formattedSeconds}`;
    };

    const onClickChangPhone = () => {
        setCodeValue({
            0: "",
            1: "",
            2: "",
            3: "",
        });
        setSendPhone(false);
    };

    const handlePhonePaste = (e) => {
        const pastedText = e.clipboardData?.getData("text/plain");
        if (!pastedText?.trim()) return;

        const pastedDigits = pastedText.replace(/\D/g, "");
        let digits = pastedDigits;

        if (pastedDigits.length === 10) {
            digits = `7${pastedDigits}`;
        } else if (pastedDigits.length === 11 && pastedDigits.startsWith("8")) {
            digits = `7${pastedDigits.slice(1)}`;
        } else if (pastedDigits.length !== 11 || !pastedDigits.startsWith("7")) {
            return;
        }

        const el = inputPhoneRef?.current;
        if (!el) return;

        const formatted = formatPhoneNumber(digits);
        if (!formatted) return;

        e.preventDefault();
        el.value = formatted;
        el.setSelectionRange(formatted.length, formatted.length);
        setFocusMask(true);
        setInputFieldsState((prev) => ({ ...prev, phone: digits }));
        setTriggerIcon((prev) => ({ ...prev, phone: digits.length >= 11 ? 3 : 2 }));
    };

    const renderVerifyBlock = () => {
        const cfg = providerConfig[smsProviderType || "smsMts"];
        if (!cfg) return null;

        return (
            <div className={`ab-2659 call-window ${className}`}>
                <div className="call-window__block">
                    <span className="call-window__title">{cfg.title}</span>
                    <div className="call-window__repeated">
                        <span className="call-window__text">{cfg.text}</span>
                        <span className="call-window__phone">{formatPhoneNumber(inputFieldsState.phone, true)}</span>
                        <div
                            className="call-window__change-phone-btn"
                            onClick={() => {
                                if (smsProviderType === "pushMts") {
                                    setTimer(59000 * 2);
                                } else {
                                    setTimer(59000);
                                }
                                onClickChangPhone();
                                inputPhoneRef.current.value = formatPhoneNumber(inputFieldsState.phone);
                                // shouldStopRef.current = false;
                                setLoaderBtn(false);
                                setTriggerIcon((prev) => {
                                    return { ...prev, phone: 1 };
                                });
                            }}
                        >
                            Изменить
                        </div>
                    </div>
                </div>

                <div className={`form__number-input ${error ? "error" : ""}`}>{inputsItems}</div>
                {errorCode ? <span className="error__text">{errorCode}</span> : null}
                <ButtonUi
                    onClick={() => {
                        setCodeValue({ 0: "", 1: "", 2: "", 3: "" });
                        document.querySelector(".form__number-input")?.classList.remove("error");
                        setTimer(59000);
                        shouldStopRef.current = false;
                        setLoaderBtn(true);
                        handleClick(true);
                    }}
                    label={timer > 0 ? `Повторное смс через ${sec(timer)}` : "Отправить код повторно"}
                    className="call-window__recall-button"
                    disabled={timer > 0}
                />

                {/* <span className="call-window__recall-desc">
                    {tooManyReq ? (
                        cfg.extra || "Превышен лимит запросов"
                    ) : timer > 0 ? (
                        cfg.repeat(sec(timer))
                    ) : (
                        <div
                            className="call-window__recall-button"
                            onClick={() => {
                                setCodeValue({ 0: "", 1: "", 2: "", 3: "" });
                                document.querySelector(".form__number-input")?.classList.remove("error");
                                setTimer(59000);
                                shouldStopRef.current = false;
                                setLoaderBtn(true);
                                handleClick(true);
                            }}
                        >
                            {cfg.repeatBtn}
                        </div>
                    )}
                </span> */}
            </div>
        );
    };

    return (
        <>
            {sendPhone ? (
                renderVerifyBlock()
            ) : (
                <div className={`ab-2659 form-input__phone ${error ? "error" : ""} ${inputFieldsState.phone.length > 10 ? "filled" : ""} ${className}`.trim()}>
                    <InputMask
                        autoComplete="new-password"
                        ref={inputPhoneRef}
                        onChange={handlePhone}
                        onPaste={handlePhonePaste}
                        mask={maskType}
                        showMask={focusMask} // ✅ Boolean достаточно, тернарник не нужен
                        replacement={{ _: /\d/ }}
                        autoFocus={autoFocus}
                        className={`input_phone ${inputFieldsState.phone?.length > 1 ? "" : "empty"} ${focusMask || inputFieldsState.phone.length ? "focus" : ""}`}
                        id="phones"
                        onFocus={() => {
                            const stateDigits = inputFieldsState.phone && inputFieldsState.phone !== false ? String(inputFieldsState.phone).replace(/\D/g, "") : "";
                            const inputDigits = inputPhoneRef.current?.value?.replace(/\D/g, "") ?? "";

                            if (stateDigits.length > 1 && inputDigits !== stateDigits) {
                                inputPhoneRef.current.value = formatPhoneNumber(inputFieldsState.phone);
                            }

                            if (inputDigits.length > 1 || stateDigits.length > 1) {
                                setFocusMask(true);
                                return;
                            }

                            inputPhoneRef.current.value = "+7 (___) ___-__-__";
                            setFocusMask(true);
                            setTriggerIcon((prev) => {
                                return { ...prev, phone: 1 };
                            });
                        }}
                        onBlur={() => {
                            setFocusMask(false);
                            if (inputFieldsState.phone.length === 1 && inputFieldsState.phone === "7") {
                                setInputFieldsState((prev) => ({ ...prev, phone: false }));
                                inputPhoneRef.current.value = "";
                                setTriggerIcon((prev) => {
                                    return { ...prev, phone: 0 };
                                });
                            }

                            if (!inputFieldsState.phone.length) {
                                inputPhoneRef.current.value = "";
                                setTriggerIcon((prev) => {
                                    return { ...prev, phone: 0 };
                                });
                            }
                        }}
                    />
                    <label className="label">Ваш номер телефона</label>
                    {icon && inputFieldsState.phone?.length > 1 ? (
                        <img
                            src={icon}
                            className="default__icon"
                            onClick={() => {
                                setInputFieldsState((prev) => {
                                    return { ...prev, phone: false };
                                });
                                setTriggerIcon((prev) => {
                                    return { ...prev, [id]: 0 };
                                });
                                inputPhoneRef.current.value = "";
                            }}
                        />
                    ) : null}
                </div>
            )}
        </>
    );
};

const providerConfig = {
    smsMts: {
        title: "Введите код из SMS",
        text: "Отправили на номер:",
        repeat: (sec) => `Повторный запрос через ${sec}`,
        repeatBtn: "Повторный запрос",
        extra: (
            <>
                <TooltipUI
                    style={{ maxWidth: "232px", textAlign: "center", padding: "10.5px" }}
                    pt={{ text: { style: { fontSize: "10px", fontWeight: 400, lineHeight: "12px" } } }}
                    target=".call-window__notcome"
                    position="bottom"
                    content="Не удалось подтвердить ваш телефон. Проверьте&nbsp;номер и интернет-соединение и&nbsp;попробуйте ещё раз. Если не получится — выберите другой подарок."
                />
                <div className="call-window__notcome">
                    <i />
                    <span>Не смогли доставить код</span>
                </div>
            </>
        ),
    },

    smsMtsRepeat: {
        title: "Введите код из SMS",
        text: "Отправили на номер:",
        repeat: (sec) => `Повторный запрос через ${sec}`,
        repeatBtn: "Повторный запрос",
        extra: (
            <>
                <TooltipUI
                    style={{ maxWidth: "232px", textAlign: "center", padding: "10.5px" }}
                    pt={{ text: { style: { fontSize: "10px", fontWeight: 400, lineHeight: "12px" } } }}
                    target=".call-window__notcome"
                    position="bottom"
                    content="Не удалось подтвердить ваш телефон. Проверьте&nbsp;номер и интернет-соединение и&nbsp;попробуйте ещё раз. Если не получится — выберите другой подарок."
                />
                <div className="call-window__notcome">
                    <i />
                    <span>Не смогли доставить код</span>
                </div>
            </>
        ),
    },
    smsProsto: {
        title: "Введите код из SMS",
        text: "Отправили на номер:",
        repeat: (sec) => `Повторный звонок через ${sec}`,
        repeatBtn: "Повторный звонок",
        extra: (
            <>
                <TooltipUI
                    style={{ maxWidth: "232px", textAlign: "center", padding: "10.5px" }}
                    pt={{ text: { style: { fontSize: "10px", fontWeight: 400, lineHeight: "12px" } } }}
                    target=".call-window__notcome"
                    position="bottom"
                    content="Не удалось подтвердить ваш телефон. Проверьте&nbsp;номер и интернет-соединение и&nbsp;попробуйте ещё раз. Если не получится — выберите другой подарок."
                />
                <div className="call-window__notcome">
                    <i />
                    <span>Телефон не подтвержден</span>
                </div>
            </>
        ),
    },

    pushMts: {
        title: "Подтвердите вход на телефоне, чтобы получить подарок, либо дождитесь смс.",
        text: "Отправили на номер:",
        repeat: (sec) => `Повторный запрос через ${sec}`,
        repeatBtn: "Повторный запрос",
        // noCode: true,
    },
    smsProsto2: {
        title: "Введите код из SMS",
        text: "Отправили на номер:",
        repeat: (sec) => `Повторный звонок через ${sec}`,
        repeatBtn: "Повторный звонок",
    },
};

export default InputTextUi;
